import React, { useState } from "react"
import styled from "styled-components"
import CompleteBG from "./CompleteBG"
import CompleteForm from "./CompleteForm"
import CircleBG from "./CircleBG"

export default function CompleteQA({
  setPage,
  setName,
  name,
  summaryCount,
  email,
  setEmail,
  GetAndShare
}) {
  const [QAAnimation, setQAAnimation] = useState(false)

  return (
    <Wrapper className={QAAnimation === true && "active"}>
      {/* <Button
        onClick={() => {
          setQAAnimation(!QAAnimation)
        }}
      >
        動畫按鈕
      </Button> */}
      <BGWrapper>
        <CompleteBG className="BGWrapper" />
        <CircleBG className="CircleBG" />
      </BGWrapper>
      <FormWrapper className="FormWrapper">
        <CompleteForm
          setPage={setPage}
          setName={setName}
          name={name}
          setQAAnimation={setQAAnimation}
          QAAnimation={QAAnimation}
          summaryCount={summaryCount}
          setEmail={setEmail}
          email={email}
          GetAndShare={GetAndShare}
        />
      </FormWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;

  &.active {
    .FormWrapper {
      opacity: 1;
      animation: zoomOut 1s forwards;
      will-change: transform;
    }
    .BGWrapper {
      opacity: 1;
      animation: fadOut 1s forwards;
    }
    .CircleBG {
      animation: fadOut 2s forwards 1s;
      .c1 {
        animation: circle 2s infinite ease reverse;
      }
      .c2 {
        animation: circle 2s infinite ease 0.5s reverse;
      }
      .c3 {
        animation: circle 2s infinite ease 1s reverse;
      }
    }
  }
  @keyframes zoomOut {
    50% {
      opacity: 1;
      transform: scale(1.2);
    }
    100% {
      opacity: 0;
      transform: scale(0.1) rotate(90deg);
      /* background-color: #00fff0; */
    }
  }
  @keyframes fadOut {
    100% {
      opacity: 0;
    }
  }
  @keyframes fadeIn {
    100% {
      opacity: 1;
    }
  }
`
const BGWrapper = styled.div`
  background-color: #000000;
  width: 100%;
  height: var(--vh);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  opacity: 0;
  will-change: transform;
  animation: fadeIn forwards 2s 1.5s;
`

const FormWrapper = styled.div`
  max-width: 400px;
  width: 100%;
  padding: 30px;
  z-index: 30;
  will-change: transform;
  opacity: 0;
  animation: fadeIn forwards 1s;
`
